export const getModalBodyScrollStyles = (scrollElement, scrollPosition)=>{
    const clientHeight = scrollElement?.clientHeight ?? 0;
    const scrollHeight = scrollElement?.scrollHeight ?? 0;
    const hasVerticalScroll = scrollHeight > clientHeight;
    if (!hasVerticalScroll) {
        return {};
    }
    const isScrolledToTop = scrollPosition.y === 0;
    if (isScrolledToTop) {
        return {
            boxShadow: 'inset 0px -2px 4px 0px rgba(0, 0, 0, 0.06)'
        };
    }
    const isScrolledToBottom = scrollPosition.y + clientHeight >= scrollHeight;
    if (isScrolledToBottom) {
        return {
            boxShadow: 'inset 0px 2px 4px 0px rgba(0, 0, 0, 0.06)'
        };
    }
    return {
        boxShadow: 'inset 0px 2px 4px 0px rgba(0, 0, 0, 0.06), inset 0px -2px 4px 0px rgba(0, 0, 0, 0.06)'
    };
};

//# sourceMappingURL=getModalBodyScrollStyles.js.map